<section [formGroup]="loan.form" fxLayout="row" fxLayout.xs="column"
         fxLayoutGap="15px">

  <bb-number number="6"></bb-number>
  <div fxLayout="column" fxFlex="80">
    <div class="request-txt">{{ 'Terms And Conditions'|uppercase }}</div>

    <mat-checkbox class="custom-checkbox" color="primary"  required formControlName="has_accepted">
      I have read, understood and agreed to the
      <a href="/terms-and-conditions" target="_blank">Terms and Conditions</a> and
      <a href="/privacy-statement" target="_blank">Privacy Policy.</a>
    </mat-checkbox>
    <mat-error *ngIf="loan.form.get('has_accepted').dirty
                 && loan.form.get('has_accepted').hasError('required')">Required.
    </mat-error>
  </div>
</section>
